import instance from './DefaultApi';

export default class SecondaryReportService {
    ControllerName = 'SecondaryReport';

    // get all data
    GetSecondaryReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSecondaryReport`, tableRequest).then(res => res)
    }
    GetSecondaryManualReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSecondaryManualReport`, tableRequest).then(res => res)
    }
    GetSecondaryManualMainReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSecondaryManualMainReport`, tableRequest).then(res => res)
    }
   //get export for report
    GetReportExport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetReportExport`, tableRequest).then(res => res)
    }

    GetReportExportManual(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetReportExportManual`, tableRequest).then(res => res)
    }
    // DeleteManualRecord(Id) {
    //     return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DeleteManualRecord/${Id}').then(res => res)
    // }

    DeleteManualRecord(Id) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DeleteManualRecord/${Id}`).then(res => res);
    }
    GetReportExportManualReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetReportExportManualReport`, tableRequest).then(res => res)
    }

}